export const getDeliverableId = state => state.deliverable.getIn(['data', 'id']);
export const getDeliverableName = state => state.deliverable.getIn(['data', 'title']);
export const getDocumentId = state => state.deliverable.getIn(['mostRecentDocument', 'id']);
export const getDocumentApproved = state => state.deliverable.getIn(['data', 'document', 'approved']);
export const getDeliverableComments = state => state.deliverable.getIn(['data', 'comments']);
export const getDiscussionId = state => state.deliverable.getIn(['data', 'discussion', 'id']);
export const getCampaignId = state => state.deliverable.getIn(['data', 'discussion', 'campaign', 'id']);
export const getCampaignName = state => state.deliverable.getIn(['data', 'discussion', 'campaign', 'name']);
export const getDiscussionName = state => state.deliverable.getIn(['data', 'discussion', 'name']);
export const getCommentsPerPage = state => state.deliverable.get('commentsPerPage');
export const getActiveCommentsPage = state => state.deliverable.get('activeCommentsPage');
export const getDocumentByVersion = (state, version) => state.deliverable.getIn(['data', 'documents', `${version}`]);



/** WEBPACK FOOTER **
 ** ./src/selectors/deliverable-selectors.js
 **/